console.log('🔧 DEBUG Frequency Buttons démarré');

setTimeout(() => {  // Délai pour Recharge
  const wrapper = document.querySelector('.rb-frequency-wrapper [data-rb-selling-plan-count]');
  console.log('Wrapper trouvé:', wrapper);
  
  if (!wrapper) {
    console.error('❌ Wrapper NON trouvé - vérifie le sélecteur');
    return;
  }
  
  const select = wrapper.querySelector('select');
  console.log('Select trouvé:', select);
  
  if (!select || select.style.display === 'none') {
    console.log('✅ Déjà traité ou pas de select');
    return;
  }

  // MASQUER IMMÉDIATEMENT
  select.style.display = 'none';
  const label = wrapper.querySelector('label');
  if (label) label.style.display = 'none';
  
  console.log('✅ Masquage OK, création boutons...');
  
  // Créer boutons
  const buttonContainer = document.createElement('div');
  buttonContainer.className = 'frequency-buttons';
  wrapper.appendChild(buttonContainer);
  
  Array.from(select.options).forEach((option, i) => {
    const button = document.createElement('button');
    button.className = 'freq-btn';
    button.dataset.value = option.dataset.sellingPlanId;
    button.dataset.index = i;
    button.innerHTML = option.innerHTML;
    if (option.selected) button.classList.add('selected');
    buttonContainer.appendChild(button);
  });
  
  console.log('✅ Boutons créés:', buttonContainer.innerHTML);
  
  // Écouteurs
  buttonContainer.querySelectorAll('.freq-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      buttonContainer.querySelectorAll('.freq-btn').forEach(b => b.classList.remove('selected'));
      this.classList.add('selected');
      select.selectedIndex = parseInt(this.dataset.index);
      select.dispatchEvent(new Event('change', {bubbles: true}));
      console.log('✅ Sélection:', this.dataset.value);
    });
  });
  
  console.log('🎉 Frequency Buttons ACTIVÉ');
}, 2000);  // Attendre Recharge
